var React = require('react');

function Messenger (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"messenger","d":"M0,13.508C0,5.744,6.08,0,13.925,0S27.85,5.744,27.85,13.508,21.77,27.015,13.925,27.015A15.2,15.2,0,0,1,9.9,26.481a1.114,1.114,0,0,0-.743.058L6.382,27.758a1.114,1.114,0,0,1-1.567-.986l-.081-2.483a1.126,1.126,0,0,0-.371-.789A13.217,13.217,0,0,1,0,13.508Zm9.655-2.541-4.085,6.5a.654.654,0,0,0,.952.87l4.4-3.33a.819.819,0,0,1,1.01,0l3.249,2.437a2.1,2.1,0,0,0,3.017-.557l4.085-6.5a.655.655,0,0,0-.952-.87l-4.4,3.33a.8.8,0,0,1-1,0l-3.249-2.437a2.089,2.089,0,0,0-3.029.557Z","transform":"translate(0.002)"}));
}

Messenger.defaultProps = {"width":"27.852","height":"27.854","viewBox":"0 0 27.852 27.854"};

module.exports = Messenger;

Messenger.default = Messenger;
